import { useMediaQuery } from '@mui/material'

export const useMediaLgUp = () => useMediaQuery((theme) => theme.breakpoints.up('lg'))
